import { createApp } from 'vue';
import components from './components';

const app = createApp({
  components,
});

app.mount('#app');
